._copyButton_1gwvw_1 {
  cursor: pointer; }
